import { motion, animate, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import Instagram from "./images/insta.svg";
import Github from "./images/github.svg";
import Linkedin from "./images/linkedin.svg";
import X from "./images/svg1.svg";
import Facebook from "./images/facebook.svg";
import CSS from "./images/css.svg";
import tailwindCss from "./images/tailwindcss.svg";
import StyledCompo from "./images/styled-components.png";
import feamerMotion from "./images/framer-motion.svg";
import ReactJs from "./images/reactjs.svg";
import Javascript from "./images/javascript.svg";
import Html from "./images/html.svg";
import Mongodb from "./images/mongodb.png";
import NodeJs from "./images/nodejs.svg";
import NextJS from "./images/nextjs.svg";
import aboutImg from "./images/IMG_2742.JPG";

import React from "react";

const CountUp = ({ to, duration = 1.6 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration,
      ease: [0.2, 0.8, 0.2, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to, duration]);

  return <span ref={ref}>{display}</span>;
};

const About = () => {
  const socialIcons = [
    {
      url: Instagram,
      link: "https://www.instagram.com/sanya_ololade/",
      label: "Instagram",
    },
    {
      url: Linkedin,
      link: "https://www.linkedin.com/in/ololade-sanya-106990272/",
      label: "LinkedIn",
    },
    {
      url: X,
      link: "https://twitter.com/Sanya_Ololade",
      label: "X",
    },
    {
      url: Github,
      link: "https://github.com/LollyTim",
      label: "GitHub",
    },
    {
      url: Facebook,
      link: "https://web.facebook.com/profile.php?id=61552501215762",
      label: "Facebook",
    },
  ];

  const stack = [
    { logo: Html, label: "HTML" },
    { logo: CSS, label: "CSS" },
    { logo: Javascript, label: "JavaScript" },
    { logo: NextJS, label: "Next.js" },
    { logo: StyledCompo, label: "Styled Components" },
    { logo: feamerMotion, label: "Framer Motion" },
    { logo: tailwindCss, label: "Tailwind" },
  ];

  const mern = [
    { logo: Mongodb, label: "MongoDB" },
    { label: "Express", letter: "Ex" },
    { logo: ReactJs, label: "React" },
    { logo: NodeJs, label: "Node" },
  ];

  return (
    <section id="about" className="w-[90%] lg:w-[90%] text-textClr dark:text-textClrDark flex mt-12 pb-12 justify-center items-center mx-auto">
      <div className="flex flex-col gap-6 lg:w-[80%] w-[90%] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div>
            <motion.p
              initial={{ opacity: 0, x: -10 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="text-xs tracking-[0.25em] uppercase opacity-50 font-medium"
            >
              — Introduction
            </motion.p>
            <h2 className="text-5xl lg:text-7xl font-semibold leading-tight tracking-tight mt-4">
              Building for the <span className="text-accentClr dark:text-accentClrDark italic font-serif">future</span>.
            </h2>
          </div>
          <p className="text-sm opacity-60 lg:max-w-xs">
            A quick snapshot of who I am, the stack I use daily, and the philosophy behind my code.
          </p>
        </div>

        <div className="w-full lg:grid lg:grid-cols-5 gap-6">
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            viewport={{ once: true }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{
              delay: 0.2,
              x: { type: "spring", stiffness: 200 },
              opacity: { duration: 1.2 },
              ease: "easeIn",
              duration: 1.2,
            }}
            className="dark:bg-darkgbg bg-lightgbg border border-[#e5e7eb] dark:border-white/10 py-8 px-9 lg:col-span-3 w-full rounded-[2.2rem] flex flex-col gap-3 shadow-sm"
          >
            <h3 className="text-xl font-semibold">
              About <span className="text-accentClr dark:text-accentClrDark">Me</span>
            </h3>
            <p className="font-normal text-[15px] lg:text-base leading-relaxed opacity-90">
              A product-focused engineer crafting clean,
              performant interfaces with React, Next.js, and React Native. 
              Winner of multiple Web3 hackathons, I specialize in bridging 
              technical complexity with intuitive UX across the SaaS and 
              blockchain ecosystems.
            </p>
            <div className="flex flex-wrap gap-2 mt-2">
              {["Web", "Mobile", "Web3", "UI Engineering", "APIs"].map((t) => (
                <span
                  key={t}
                  className="text-[11px] px-2.5 py-1 rounded-full border border-accentClr/30 dark:border-accentClrDark/40 text-accentClr dark:text-accentClrDark bg-accentClr/5 dark:bg-accentClrDark/10"
                >
                  {t}
                </span>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ x: 100, opacity: 0 }}
            viewport={{ once: true }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{
              delay: 0.1,
              x: { type: "spring", stiffness: 200 },
              opacity: { duration: 0.8 },
              ease: "easeIn",
              duration: 1,
            }}
            className="dark:bg-darkgbg bg-lightgbg border border-[#e5e7eb] dark:border-white/10 justify-center lg:col-span-2 items-center flex rounded-[2.2rem] py-8 mt-6 lg:mt-0 shadow-sm"
          >
            <div
              className="lg:w-[160px] lg:h-[160px] w-[200px] h-[200px] border border-accentClr dark:border-accentClrDark bg-center bg-cover rounded-full"
              style={{
                backgroundImage: `url(${aboutImg})`,
                backgroundSize: 500,
                backgroundPositionX: "-180px",
              }}
            />
          </motion.div>
        </div>

        <div className="w-full lg:grid lg:grid-cols-5 gap-6">
          <div className="w-full grid grid-cols-2 gap-6 lg:col-span-2 mb-6 lg:mb-0">
            <motion.div
              initial={{ scale: 0, opacity: 0 }}
              viewport={{ once: true }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{
                delay: 0.1,
                scale: { type: "spring", stiffness: 200 },
                opacity: { duration: 0.8 },
                ease: "easeIn",
                duration: 1,
              }}
              className="rounded-[2.2rem] dark:bg-darkgbg bg-lightgbg border border-[#e5e7eb] dark:border-white/10 flex flex-col justify-center py-8 w-full items-center shadow-sm"
            >
              <h1 className="text-5xl lg:text-6xl font-semibold">
                <CountUp to={3} />
                <span className="text-accentClr dark:text-accentClrDark">+</span>
              </h1>
              <p className="text-sm opacity-70 text-center mt-1">
                Years of Experience
              </p>
            </motion.div>
            <motion.div
              initial={{ scale: 0, opacity: 0 }}
              viewport={{ once: true }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{
                delay: 0.1,
                scale: { type: "spring", stiffness: 200 },
                opacity: { duration: 0.8 },
                ease: "easeIn",
                duration: 1,
              }}
              className="rounded-[2.2rem] gap-1 dark:bg-darkgbg bg-lightgbg border border-[#e5e7eb] dark:border-white/10 w-full flex flex-col justify-center items-center py-8 shadow-sm"
            >
              <h1 className="text-5xl lg:text-6xl font-semibold">
                <CountUp to={12} />
                <span className="text-accentClr dark:text-accentClrDark">+</span>
              </h1>
              <p className="text-sm opacity-70 mt-1">Projects Shipped</p>
            </motion.div>
          </div>

          <motion.div
            initial={{ x: 100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{
              delay: 0.1,
              x: { type: "spring", stiffness: 200 },
              opacity: { duration: 0.8 },
              ease: "easeIn",
              duration: 1,
            }}
            className="relative w-full rounded-[2.2rem] lg:col-span-3 overflow-hidden border border-accentClr/20 dark:border-accentClrDark/20 bg-gradient-to-br from-accentClr/5 via-accentClr/10 to-transparent dark:from-accentClrDark/10 dark:via-accentClrDark/15 shadow-sm"
          >
            <motion.div
              aria-hidden
              animate={{ rotate: 360 }}
              transition={{ duration: 24, repeat: Infinity, ease: "linear" }}
              className="pointer-events-none absolute -top-10 -right-10 w-40 h-40 rounded-full blur-2xl"
              style={{
                background:
                  "conic-gradient(from 0deg, rgba(220,38,38,0.35), transparent 50%, rgba(239,68,68,0.3) 80%, transparent)",
              }}
            />
            <div className="relative flex flex-col sm:flex-row items-start sm:items-center gap-5 p-6 h-full">
              <motion.div
                whileHover={{ rotate: [-6, 6, -4, 0], scale: 1.08 }}
                transition={{ duration: 0.6 }}
                className="flex-none w-16 h-16 rounded-2xl bg-accentClr dark:bg-accentClrDark text-white flex items-center justify-center text-3xl shadow-lg shadow-accentClr/20 dark:shadow-accentClrDark/20"
                aria-hidden
              >
                🏆
              </motion.div>
              <div className="flex-1">
                <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest opacity-70">
                  <span className="text-accentClr dark:text-accentClrDark font-semibold">2×</span>
                  <span>Hackathon Winner</span>
                </div>
                <h3 className="text-lg lg:text-xl font-semibold mt-1 leading-tight">
                  Shipped winning builds on{" "}
                  <span className="text-accentClr dark:text-accentClrDark">Cardano</span>{" "}
                  &amp; <span className="text-accentClr dark:text-accentClrDark">Hyperliquid</span>
                </h3>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  <span className="flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full border border-black/10 dark:border-white/15 bg-white/60 dark:bg-black/30">
                    <span className="h-2 w-2 rounded-full bg-[#0033AD]" />
                    Cardano
                  </span>
                  <span className="flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full border border-black/10 dark:border-white/15 bg-white/60 dark:bg-black/30">
                    <span className="h-2 w-2 rounded-full bg-[#97FCE4]" />
                    Hyperliquid
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="md:w-full flex flex-col md:grid md:grid-cols-5 gap-6">
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            viewport={{ once: true }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{
              delay: 0.1,
              scale: { type: "spring", stiffness: 200 },
              opacity: { duration: 0.8 },
              ease: "easeIn",
              duration: 1,
            }}
            className="gap-4 rounded-[2.2rem] dark:bg-darkgbg bg-lightgbg border border-[#e5e7eb] dark:border-white/10 md:col-span-2 flex py-4 px-6 justify-center items-center shadow-sm"
          >
            {socialIcons.map((icon, i) => (
              <a
                href={icon.link}
                target="_blank"
                rel="noopener noreferrer"
                key={i}
                aria-label={icon.label}
                className="hover:scale-110 transition-transform"
              >
                <img src={icon.url} alt={icon.label} className="size-10" />
              </a>
            ))}
          </motion.div>

          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            viewport={{ once: true }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{
              delay: 0.1,
              scale: { type: "spring", stiffness: 200 },
              opacity: { duration: 0.8 },
              ease: "easeIn",
              duration: 1,
            }}
            className="rounded-[2.2rem] dark:bg-darkgbg bg-lightgbg border border-[#e5e7eb] dark:border-white/10 md:col-span-2 flex justify-center items-center gap-5 py-4 px-6 shadow-sm"
          >
            {stack.map((each, id) => (
              <div key={id} title={each.label} className="opacity-90 hover:opacity-100 transition-opacity">
                <img src={each.logo} alt={each.label} className="size-10 max-h-10 w-12 object-contain" />
              </div>
            ))}
          </motion.div>

          <motion.div
            initial={{ y: 100, opacity: 0 }}
            viewport={{ once: true }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{
              delay: 0.1,
              y: { type: "spring", stiffness: 200 },
              opacity: { duration: 0.8 },
              ease: "easeIn",
              duration: 1,
            }}
            className="rounded-[2.2rem] dark:bg-darkgbg bg-lightgbg border border-[#e5e7eb] dark:border-white/10 gap-3 justify-center items-center flex px-4 py-8 shadow-sm"
            title="MERN Stack"
          >
            {mern.map((item, idx) => (
              <div key={idx} className="flex flex-col justify-center items-center gap-1">
                {item.logo ? (
                  <img src={item.logo} alt={item.label} className="size-8" />
                ) : (
                  <span className="text-textClr dark:text-textClrDark text-lg font-medium h-8 flex items-center">
                    {item.letter}
                  </span>
                )}
                <p className="text-[11px] opacity-70">{item.label}</p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
